import React from 'react';
import cn from 'classnames';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { UiKit, Callout } from 'components';
import { ReactComponent as HourglassIcon } from 'assets/img/icons/hourglass.svg';
import { ReactComponent as WarningIcon } from 'assets/img/icons/warning-red.svg';
import { If } from 'utils';

const ICON_MAP = {
  info: HourglassIcon,
  error: WarningIcon
};

export default function Alert({
  type = 'info',
  children = null,
  className = '',
  iconClassName = ''
}) {
  const Icon = _get(ICON_MAP, type, () => null);
  const isChildrenString = typeof children === 'string';

  return (
    <Callout
      type={type}
      className={cn(styles.container, className, {
        [styles.info]: type === 'info',
        [styles.error]: type === 'error'
      })}
    >
      <Callout.Content className={styles.content}>
        <UiKit.Grid gap="8" templateColumns="auto 1fr" className={styles.row}>
          <div className={cn(styles.icon, iconClassName)}>
            <Icon />
          </div>
          <If test={isChildrenString}>
            <p className={styles.title}>{children}</p>
          </If>
        </UiKit.Grid>
        <If test={!isChildrenString}>{children}</If>
      </Callout.Content>
    </Callout>
  );
}
